import React from "react";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";

const PartyLoading = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.screen}>
      <CircularProgress />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  screen: {
    display: "flex",
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default PartyLoading;
